import React from 'react';
import { Route, IndexRoute } from 'react-router';
import { lazify } from '../Common/Helper';
import { willRequireLogin } from '../Auth';
/* eslint-disable */
import CartContainer from 'split-chunk-loader?lazy!../Checkout/CartContainer';
import ShippingContainer from
  'split-chunk-loader?lazy!../Checkout/ShippingAndPayment/ShippingContainer';
import StripeAfterCompletePayment from 'split-chunk-loader?lazy!../Checkout/ShippingAndPayment/StripeAfterCompletePayment';
import AdyenSelfHostedPage from 'split-chunk-loader?lazy!../Checkout/ShippingAndPayment/AdyenSelfHostedPage';
import AdyenAfterCompletePayment from 'split-chunk-loader?lazy!../Checkout/ShippingAndPayment/AdyenAfterCompletePayment'
import TazapayAfterPayment from 'split-chunk-loader?lazy!../Checkout/ShippingAndPayment/TazapayAfterPayment';
import PaypalSelfHostedPage from 'split-chunk-loader?lazy!../Checkout/ShippingAndPayment/Paypal/PaypalSelfHostedPage'
import PaypalAfterPayment from 'split-chunk-loader?lazy!../Checkout/ShippingAndPayment/Paypal/PaypalAfterPayment';
/* eslint-enable */

const Routes = (
    <Route
      label='My Cart'
      path='checkout'
    >
      <Route label='My Cart' path='cart'>
        <IndexRoute component={willRequireLogin(lazify(CartContainer))} >
        </IndexRoute>
      </Route>

      <Route path='shipping'>
        <IndexRoute component={willRequireLogin(lazify(ShippingContainer))}/>
      </Route>

      <Route path='payment'>
        <IndexRoute component={willRequireLogin(lazify(StripeAfterCompletePayment))}/>
      </Route>

      <Route path='adyen-shp'>
        <IndexRoute component={lazify(AdyenSelfHostedPage)}/>
      </Route>

      <Route path='adyen-shp-return'>
        <IndexRoute component={lazify(AdyenAfterCompletePayment)}/>
      </Route>
      <Route path='tazapay-return'>
        <IndexRoute component={lazify(TazapayAfterPayment)}/>
      </Route>
      <Route path='paypal-shp'>
          <IndexRoute component={lazify(PaypalSelfHostedPage)}/>
      </Route>
      <Route path='paypal-return'>
        <IndexRoute component={lazify(PaypalAfterPayment)}/>
      </Route>
    </Route>
);

export default Routes;



// WEBPACK FOOTER //
// ./src/Routes/CheckoutRoutes.js